import DescriptionIcon from '@mui/icons-material/Description';

import InvoiceList from './InvoiceList';
import InvoiceCreate from './InvoiceCreate';
import InvoiceEdit from './InvoiceEdit';
import InvoiceShow from './InvoiceShow';

const invoices = {
	list: InvoiceList,
	create: InvoiceCreate,
	show: InvoiceShow,
	edit: InvoiceEdit,
	icon: DescriptionIcon
};

export default invoices;
